<template>
  <div>
    <Transition name="notification">
      <div
        class="betslipNotification"
        v-if="isLoaded && isNotificationActive"
        :style="{ '--footerHeight': footerHeight }"
      >
        <Notification type="terminal" />
      </div>
    </Transition>
    <div class="betslipFooter" ref="footer" >
      <div class="betslipFooterUpper">
        <div class="betslipUpperWrapperA">
          <div class="betslipFooterSelect"
            v-if="isFuturePerTicketAllowed"
            :class="{ paymentPerBetDisabled: !isPaymentPerBetAllowed }">
            <Select
              :label="translations.general_future_bet"
              :options="selectOptions"
              :value="futureRounds"
              @change="handleFutureRoundsChange"
              type="terminal"
            />
          </div>
          <div
            v-if="isPaymentPerBetAllowed"
            class="betslipFooterInput"
            :class="{ futurePerTicketDisabled: !isFuturePerTicketAllowed }">
            <BetslipInput
              @change="handlePaymentPerBetChange"
              @fieldFocus="setActivePaymentPerBetInput"
              type="terminal"
              :label="translations.general_stake_per_bet"
              :parentValue="paymentPerBet"
              :readonly=true
              @delete="handlePaymentPerBetDelete"
              :isValid="isPaymentPerBetValid"
            />
          </div>
          <BetslipInput
            class="totalPayment"
            @change="handleTotalPaymentChange"
            @fieldFocus="setActiveTotalStakeInput"
            type="terminal"
            :label="translations.general_total_stake"
            :labelPosition="isLeftSideLabel ? 'left' : 'right'"
            :parentValue="totalPayment"
            :readonly=true
            @delete="handleTotalPaymentDelete"
            :class="{
              futurePerTicketDisabled: !isFuturePerTicketAllowed,
              paymentPerBetDisabled: !isPaymentPerBetAllowed
            }"
          />
        </div>
      </div>
      <div class="betslipFooterLower">
        <BetslipPossibleWin />
        <div class="betslipFooterActions">
          <div class="betslipDeleteButton">
            <BetslipDeleteButton type="terminal" />
          </div>
          <div class="betslipActionButton">
            <BetslipButton type="terminal" :isTerminal="true" :disabled="isPayinDisabled" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import BetslipInput from '../../BetslipArea/GamesBetslipInput';
import Notification from '../../Notifications/Notification';
import Select from '../../Select/Select';
import BetslipButton from '../BetslipA/BetslipButton';
import BetslipDeleteButton from '../BetslipA/BetslipDeleteButton';
import BetslipPossibleWin from './BetslipPossibleWin';
import { eventBus } from '../../../utility';

export default {
  name: 'BetslipFooter',
  props: {
    isA: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      stakeBoxTimeoutId: 0,
      isLoaded: false,
    };
  },
  components: {
    BetslipInput,
    BetslipButton,
    BetslipDeleteButton,
    BetslipPossibleWin,
    Notification,
    Select,
  },
  computed: {
    ...mapGetters('gamesBetslip', [
      'config',
      'isPayinButtonDisabled',
      'isPaymentPerBetValid',
      'isPayinInProgress',
      'isTotalPaymentValid',
      'isPaymentValid',
      'isCantSplitActive',
      'isUserBalanceInvalid',
      'futureRounds',
      'futureRoundsDefault',
      'minPaymentAllowed',
      'numberOfBets',
      'paymentPerBet',
      'totalPayment',
      'isFuturePerTicketAllowed',
      'isPaymentPerBetAllowed',
    ]),
    ...mapGetters(['translations']),
    ...mapGetters('notifications', ['isNotificationActive']),
    selectOptions() {
      return this.config.futureRounds;
    },
    isPayinDisabled() {
      return this.isPayinButtonDisabled
      || this.numberOfBets <= 0
      || this.isPayinInProgress
      || !this.isTotalPaymentValid
      || !this.isPaymentValid
      || this.isCantSplitActive
      || this.isUserBalanceInvalid;
    },
    isLeftSideLabel() {
      return !this.isFuturePerTicketAllowed && this.isPaymentPerBetAllowed;
    },
    footerHeight() {
      return `${this.$refs.footer.clientHeight}px`;
    },
  },
  methods: {
    ...mapActions('gamesBetslip', [
      'paymentPerBetDelete',
      'setTotalPayment',
      'setPaymentPerBet',
      'setPaymentPerBetValue',
      'setFutureRounds',
      'setIsPaymentPerBetValid',
      'setActiveBetslipInput',
      'setIsStakeBoxVisible',
      'totalPaymentDelete',
    ]),
    handleTotalPaymentChange(totalPayment) {
      if (Number(totalPayment) === Number(this.totalPayment)) return;

      this.setTotalPayment(totalPayment);
    },
    async handlePaymentPerBetChange(paymentPerBet) {
      const isValid = await this.setPaymentPerBet(paymentPerBet);

      this.setIsPaymentPerBetValid(isValid);
    },
    handleFutureRoundsChange(futureRounds) {
      this.setFutureRounds(futureRounds);
    },
    handleTotalPaymentDelete() {
      this.totalPaymentDelete();
    },
    async handlePaymentPerBetDelete() {
      this.isPaymentPerBetValid = true;
      this.paymentPerBetDelete();
    },
    openStakeBox() {
      if (this.stakeBoxTimeoutId) clearTimeout(this.stakeBoxTimeoutId);

      this.stakeBoxTimeoutId = setTimeout(() => {
        this.setIsStakeBoxVisible(true);
      }, 200);
    },
    setActiveTotalStakeInput() {
      this.openStakeBox();
      this.setActiveBetslipInput('_totalPayment');
    },
    setActivePaymentPerBetInput() {
      this.openStakeBox();
      this.setActiveBetslipInput('_paymentPerBet');
    },
    setFooterHeightToWrapper() {
      const target = document.getElementById('betslipDWrapper');
      target.style.setProperty('--footer-height', this.footerHeight);
    },
  },
  mounted() {
    this.isLoaded = true;
    this.setFooterHeightToWrapper();

    eventBus.$on('BetslipOpened', this.setFooterHeightToWrapper);
  },
  beforeDestroy() {
    eventBus.$off('BetslipOpened', this.setFooterHeightToWrapper);
  },
};
</script>

<style lang="scss" scoped>
.betslipNotification {
  position: absolute;
  width: 100%;
  bottom: var(--footerHeight);
  z-index: 10;
}

.notification-enter-active {
  animation-name: notificationSlideUp;
  animation-duration: 0.33s;
  transition-timing-function: ease-out;
}

.notification-leave-active {
  animation-name: notificationSlideDown;
  animation-duration: 0.33s;
  transition-timing-function: ease-out;
}

@keyframes notificationSlideUp {
  from {
    bottom: calc(var(--footerHeight) - 72px);
  }

  to {
    bottom: var(--footerHeight);
  }
}

@keyframes notificationSlideDown {
   from {
    bottom: var(--footerHeight);
  }

  to {
    bottom: calc(var(--footerHeight) - 72px);
  }
}

.betslipFooter {
  position: absolute;
  bottom: 0;
  width: 100%;
  max-height: 262px;
  background-color: var(--background-2);
  padding: 8px;
  z-index: 99;

  .betslipFooterUpper {
    .betslipStakePerBet {
      margin-bottom: 8px;
    }

    .betslipUpperWrapperA {
      .betslipFooterInput {
        grid-row-start: 1;
        grid-column-start: 2;

        ::v-deep .betslip-input-wrapper {
          input {
            width: 140px;
          }
        }

        &.futurePerTicketDisabled {
          ::v-deep .betslip-input-wrapper {
            input {
              width: 140px;
            }
          }
        }
      }

      display: grid;
      gap: 8px;
      grid-template-columns: 1fr auto;

      .betslipFooterSelect {
        &.paymentPerBetDisabled {
          grid-row-start: 1;
          grid-column-start: 1;

          ::v-deep .select {
            width: 100%;
          }
        }
      }

      .paymentPerBet {
        grid-column-start: 2;
      }

      .totalPayment {
        grid-column: 1/-1;

        ::v-deep {
          input {
            width: 100%;
          }
        }

        &.futurePerTicketDisabled {
          grid-column-start: 1;
          grid-row-start: 1;
          grid-column: auto;

          ::v-deep {
            input {
              width: 100%;
            }
          }
        }

        &.paymentPerBetDisabled {
          grid-column: auto;

          ::v-deep {
            input {
              width: 188px;
            }
          }
        }

        &.futurePerTicketDisabled.paymentPerBetDisabled {
          grid-column: 1/-1;

          ::v-deep {
            input {
              width: 100%;
            }
          }
        }
      }

      ::v-deep .select {
        width: 100%;
      }
    }
  }

  .betslipUpperWrapperB {
    display: grid;
    grid-template-columns: 1fr 103px;
    gap: 8px;

    .betslipFooterInput {
      width: 103px;
    }

    &.paymentPerBetDisabled {
      grid-template-columns: 50px 1fr;
    }

    .betslipFooterSelect {
      ::v-deep .select {
        width: 100%;
      }
    }

    .betslipDeleteButton {
      grid-column: 1/-1;
      grid-row-start: 3;

      &.paymentPerBetDisabled {
        grid-column: auto;
        grid-row-start: 1;
      }

      &.futurePerTicketDisabled {
        grid-column: auto;
        grid-row-start: 1;
      }

      &.onlyDelete {
        grid-column: 1/-1;
      }
    }

    .possibleWin {
      grid-column: 1/-1;
    }
  }

  .betslipFooterLower {
    width: 100%;
    margin-top: 8px;

    .betslipFooterActions {
      display: flex;
      width: inherit;
      margin-top: 8px;
      gap: 8px;

      .betslipActionButton {
        width: inherit;
        flex: 2;
        width: 100%;
      }
    }
  }
}

.betslipDeleteButton {
  width: 120px;
}

@media only screen and (min-width: 1910px) {
  .betslipFooter {
    max-height: 341px;
  }
}
</style>
